import { AxiosInstance } from "axios";
import IMfilesValueListDefinition from "../interfaces/mfiles/IMFilesValueListDefinition";
import { fetchValueListsUrl } from "../helpers/urlHelper";

export const getAllValueListDefinitionsAsync = async (httpClient: AxiosInstance): Promise<IMfilesValueListDefinition[]> => {
  const url = fetchValueListsUrl();
  const result = await httpClient.get<IMfilesValueListDefinition[]>(url);
  return result.data;
};
